export class State {
    gocardless = false;
}
